import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { logbookListHeader } from "@/constants/defaultHeader";

export default {
	state: {
		logbooksmodItem: null,
		logbooksmodList: null,
		logbooksmodFilters: null,
		logbooksmodTotals: null,
		logbooksmodLimit: null,
		logbooksmodOrder: null,
		logbooksmodSort: null,
		logbooksmodTotal: null,
		settingsLogbooksModInventory: null,
		itemsLogbooksModInventory: null,
		filtersLogbooksModInventory: null,
		
		totalsLogbooksMod: null,
		createCustomers: [],
		createRequest: [],
	},
	mutations: {
		updateLogbooksModList(state, { customers, limit, order, sort, total }) {
			state.logbooksmodList = customers;
			state.logbooksmodLimit = limit;
			state.logbooksmodOrder = order;
			state.logbooksmodSort = sort;
			state.logbooksmodTotal = total;
		},
		updateLogbooksModFilters(state, { filter }) {
			state.logbooksmodFilters = filter;
		},
		updateLogbooksMod(state, payload) {
			state.logbooksmodItem = payload;
		},
		updateLogbooksModInventory(state, { settings, items, filters }) {
			state.settingsLogbooksModInventory = settings;
			state.itemsLogbooksModInventory = items;
			state.filtersLogbooksModInventory = filters;
		},
		updateLogbooksModTotal(state, payload) {
			state.logbooksmodTotals = payload;
		},

		updateCreateAction(state, { customers, request }) {
			state.createCustomers = customers;
			state.createRequest = request;
		},
		// updateLogbooksDriverActions(state, payload) {
		// 	payload && (state.driverActionsLogbooks = payload);
		// },
	},
	actions: {
		async getCreateAction({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/safety/create`);
				commit('updateCreateAction', data);
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},

		async deleteLogbooksModDocuments({ dispatch }, values) {
			console.info('%c [  dispatch  ] ', 'color:#bada55', typeof dispatch, dispatch );
			try {
				const { id } = values;
				const { data } = await httpClient.delete(`info/documents/${ id }`);
				if (data && data.status) {
					// ===== Заменеить на обновленеи списка инверторя =====
					// dispatch('getLogbooksModInventoryList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async deleteLogbooksModInventory({ dispatch }, values) {
			try {
				const { id, employeeId } = values;
				const { data } = await httpClient.delete(`/logbooksmod/${ employeeId }/inventory/${ id }`);
				if (data && data.status) {
					// ===== Заменеить на обновленеи списка инверторя =====
					dispatch('getLogbooksModInventoryList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getLogbooksModInventoryList({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { employeeId } = values;
				const { data } = await httpClient.get(`/logbooksmod/${ employeeId }/inventory/`);
				if (data) {
					commit('updateLogbooksModInventory', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getLogbooksMod({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/safety/list', values);

				if (data && data.status) {
					commit('updateLogbooksModList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.LOGBOOKS_MOD, defaultHeader: logbookListHeader });
					// commit('updateSettings', { settings: [], key: requestKeys.TRUCKS, defaultHeader: logbookListHeader });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getTotalLogbooksMod({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/safety/statistics`, value);

				if (data) {
					commit('updateLogbooksModTotal', data);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getLogbooksModFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/safety/filters', values);
				if (data) commit('updateLogbooksModFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onLogbooksModSave({ dispatch }, { values, id }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/logbooksmod/${ id }` : '/logbooksmod';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onLogbooksMod({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const uri = id ? `/logbooksmod/${ id }/edit` : '/logbooksmod/create';
				const { data } = await httpClient.get(uri);

				if (data && !data.status) {
					commit('updateLogbooksMod', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		// async onLogbooksDriverActions({ commit, dispatch }, payload) {
		// 	dispatch("actionPreloader", true);
		// 	const { id, date } = payload;
		//
		// 	try {
		// 		const { data } = await httpClient.get(`/safety/${ id }/${ date }`);
		//
		// 		if (data && data.status) {
		// 			commit('updateLogbooksDriverActions', data);
		// 			dispatch("actionPreloader", false);
		// 		}
		// 	} catch (e) {
		// 		console.error(e);
		// 	}
		// },
		// async addLogbooksDriverAction({ commit, dispatch }, payload) {
		// 	const { note, id, dateTime } = payload;
		// 	const driver_date = payload.date;
		//
		// 	try {
		// 		const { data } = await httpClient.post(`/safety/${ id }/${ driver_date }`, { note, dateTime });
		//
		// 		if (data && data.status) {
		// 			commit('updateLogbooksDriverActions', data);
		// 			dispatch("actionPreloader", false);
		// 		}
		// 	} catch (e) {
		// 		console.error(e);
		// 	}
		// },
		// async editLogbooksDriverAction({ commit, dispatch }, payload) {
		// 	const { note, driver_id, id, dateTime } = payload;
		// 	const driver_date = payload.date;
		//
		// 	try {
		// 		const { data } = await httpClient.post(`/safety/${ driver_id }/${ driver_date }`, { note, dateTime, id });
		//
		// 		if (data && data.status) {
		// 			commit('updateLogbooksDriverActions', data);
		// 			dispatch("actionPreloader", false);
		// 		}
		// 	} catch (e) {
		// 		console.error(e);
		// 	}
		// },

		// async deleteLogbooksDriverAction({ commit, dispatch }, payload) {
		// 	const { driver_id } = payload;
		// 	const driver_date = payload.date;
		//
		// 	try {
		// 		const { data } = await httpClient.post(`/safety/${ driver_id }/${ driver_date }`, payload);
		//
		// 		if (data && data.status) {
		// 			commit('updateLogbooksDriverActions', data);
		// 			dispatch("actionPreloader", false);
		// 		}
		// 	} catch (e) {
		// 		console.error(e);
		// 	}
		// },
		
	},
	getters: {
		logbooksmodItem: (s) => s.logbooksmodItem,
		logbooksmodList: (s) => s.logbooksmodList,
		logbooksmodFilters: (s) => s.logbooksmodFilters,
		logbooksmodTotals: (s) => s.logbooksmodTotals,
		logbooksmodLimit: (s) => s.logbooksmodLimit,
		logbooksmodOrder: (s) => s.logbooksmodOrder,
		logbooksmodSort: (s) => s.logbooksmodSort,
		logbooksmodTotal: (s) => s.logbooksmodTotal,
		settingsLogbooksModInventory: (s) => s.settingsLogbooksModInventory,
		itemsLogbooksModInventory: (s) => s.itemsLogbooksModInventory,
		filtersLogbooksModInventory: (s) => s.filtersLogbooksModInventory,
		createCustomers: (s) => s.createCustomers,
		createRequest: (s) => s.createRequest,
	}
};
